import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=a72df8de&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=a72df8de&scoped=true&lang=css&"
import style1 from "./Pagination.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72df8de",
  null
  
)

export default component.exports